import { InputGroup } from "@components/_Revamp/InputGroup";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import Dropdown from "@pages/EverGreen/Components/Dropdown";
import FlatButton from "@pages/EverGreen/Components/FlatButton";
import OthersSpecify from "@pages/EverGreen/Components/Textarea";
import { trackOnFormStartOrSuccess } from "@pages/EverGreen/Helpers/analyticsHelper";
import { isNonIncomerGroup } from "@pages/EverGreen/Helpers/helpers";
import { useAvivaSelector } from "@redux/hook";
import {
  updateAnnualIncome,
  updateEmpName,
  updateFcc,
  updateNameOfBusiness,
  updateNameOfBusinessContent,
  updateSelectedOccupation,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { SCREEN_SIZE } from "@static/screen-size";
import { EverGreenStyle } from "@utils/Style/everGreen";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

function EmploymentDetail() {
  const occupationList = useAvivaSelector(
    (state) => state.everGreenStep3.occupationList
  );
  const natureOfBusinessList = useAvivaSelector(
    (state) => state.everGreenStep3.natureOfBusinessList
  );
  const occupation = useAvivaSelector(
    (state) => state.everGreenStep3.occupation
  );
  const annualIncome = useAvivaSelector(
    (state) => state.everGreenStep3.annualIncomeList
  );
  const dispatch = useDispatch();
  const [empName, setEmpName] = useState(occupation.employerName);
  const fcc = useAvivaSelector((state) => state.everGreenStep3.occupation.fcc);
  const mappedList = useRef<any>(null);
  const mappedNatureOfBusinessList = useRef<any>(null);
  const debounceTimer = useRef<any>(null);
  const nonIncomeGroup = isNonIncomerGroup(
    occupation?.selectedOccupation?.id || ""
  );
  const [natureOfBusinessContent, setnatureOfBusinessContent] = useState(
    useAvivaSelector(
      (state) => state.everGreenStep3.occupation.natureOfBusinessContent
    )
  );
  const updateNoBContentTimer = useRef<any>(null);
  const updateNoBContent = useCallback((e) => {
    trackOnFormStartOrSuccess("DS_occupation_form");

    if (e.target.value.length > 99) {
      return;
    }
    setnatureOfBusinessContent(e.target.value);
    clearTimeout(updateNoBContentTimer.current);
    updateNoBContentTimer.current = setTimeout(() => {
      dispatch(updateNameOfBusinessContent(e.target.value));
    }, 300);
  }, []);

  useEffect(() => {
    const data = new Map();
    occupationList.forEach((val) => {
      data.set(val.id, val);
    });
    mappedList.current = data;
    console.error(mappedList.current);
  }, [occupationList]);

  useEffect(() => {
    const data = new Map();
    natureOfBusinessList.forEach((val) => {
      data.set(val.id, val);
    });
    mappedNatureOfBusinessList.current = data;
    console.error(mappedNatureOfBusinessList.current);
  }, [natureOfBusinessList]);

  return (
    <>
      <TitleSm className={heading}>Your Employment Details</TitleSm>
      <Grid>
        <Dropdown
          variant="auto-complete"
          value={occupation.selectedOccupation.id}
          placeholder="Select"
          name="occupation"
          label="Occupation"
          onChange={(e) => {
            if (mappedList.current) {
              dispatch(
                updateSelectedOccupation(mappedList.current.get(e.target.value))
              );
              if (isNonIncomerGroup(e.target.value)) {
                dispatch(updateEmpName(""));
                dispatch(updateNameOfBusiness({ id: "", label: "" }));
                setEmpName("");
              }
            }
            trackOnFormStartOrSuccess("DS_occupation_form");
          }}
          source={occupationList || []}
          bindLabel="label"
          bindId="id"
          theme={EverGreenStyle}
        />
        {!nonIncomeGroup && (
          <InputGroup
            label="Name of Employer"
            id="employer"
            inputType="input"
            textAlign="left"
            theme={EverGreenStyle}
            inputProps={{
              textAlign: "left",
              value: empName || "",
            }}
            onChange={(e) => {
              // const regex = /^[a-zA-Z]{0,1}[a-zA-Z ]{0,50}$/;
              trackOnFormStartOrSuccess("DS_occupation_form");

              const value = e.target.value;
              // if (regex.test(value)){
              if (value > 99) {
                return;
              }

              setEmpName(value);
              clearTimeout(debounceTimer.current);
              debounceTimer.current = setTimeout(() => {
                dispatch(updateEmpName(value));
              }, 500);
            }}
            onBlurShowError={true}
          />
        )}
        <Dropdown
          variant="auto-complete"
          value={occupation.selectedOccupation.id}
          placeholder="Select"
          label="Annual Income"
          id="annual-income"
          onChange={(e) => {
            trackOnFormStartOrSuccess("DS_occupation_form");

            const income = annualIncome.find(
              (a) => a.id === e.target.value
            ) || { id: "", value: "", label: "" };
            dispatch(updateAnnualIncome(income));
          }}
          source={annualIncome || []}
          bindLabel="label"
          bindId="id"
          theme={EverGreenStyle}
        />
        {!nonIncomeGroup && (
          <Dropdown
            variant="auto-complete"
            value={occupation.selectedOccupation.id}
            placeholder="Select"
            label="Nature of Business"
            id="nature-of-business"
            onChange={(e) => {
              trackOnFormStartOrSuccess("DS_occupation_form");

              dispatch(
                updateNameOfBusiness(
                  mappedNatureOfBusinessList.current.get(e.target.value)
                )
              );
            }}
            source={natureOfBusinessList || []}
            bindLabel="label"
            bindId="id"
            theme={EverGreenStyle}
          />
        )}
      </Grid>
      {occupation.natureOfBusiness.id === "17" && (
        <>
          <div
            style={{
              marginTop: "24px",
              fontSize: "14px",
              fontWeight: "500",
              color: EverGreenStyle.colors.grey[500],
            }}
          >
            Please specify{" "}
          </div>
          <OthersSpecify
            style={{ marginTop: "24px" }}
            charLimitlabel="99"
            placeholder="Message"
            value={natureOfBusinessContent}
            onChange={updateNoBContent}
          />
        </>
      )}
      <FFCContainer>
        <TitleSm>
          Are you a member of senior management or a dealer/trader/counter
          staff/ casino dealer/debt collector in the following industries?
        </TitleSm>
        <ol type="a">
          <li>Casino or other types of gaming or gambling operations</li>
          <li>Precious metals or precious stones</li>
          <li>
            Money services business includes moneylenders, pawnbrokers,
            money-changing, credit loans, remittance, etc (excludes banks)
          </li>
          <li>Oil or petroleum</li>
          <li>Virtual or digital currencies</li>
        </ol>
        <div className="fcc-btns-contianer">
          <FlatButton
            onClick={() => {
              trackOnFormStartOrSuccess("DS_occupation_form");

              dispatch(updateFcc("NO"));
            }}
            maxWidth="368px"
            isActive={fcc === "NO"}
          >
            No
          </FlatButton>
          <FlatButton
            onClick={() => {
              trackOnFormStartOrSuccess("DS_occupation_form");

              dispatch(updateFcc("YES"));
            }}
            maxWidth="368px"
            isActive={fcc === "YES"}
          >
            Yes
          </FlatButton>
        </div>
        {fcc === "YES" && (
          <div className="note">
            By selecting &lsquo;Yes&rsquo;, you will be assigned to a Financial
            Adviser Representative who will assist you with the submission of
            the required forms and supporting documents.
          </div>
        )}
      </FFCContainer>
    </>
  );
}

export default EmploymentDetail;

const FFCContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  div:first-child {
    margin-top: 8px;
  }
  ol {
    width: 100%;
    max-width: 744px;
    margin-left: 24px;
    font-size: ${EverGreenStyle.fontSize.description}px;
    margin-bottom: 24px;
  }
  .fcc-btns-contianer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
  }
  .note {
    font-size: 12px;
    width: 100%;
    max-width: 700px;
    /* letter-spacing: 1.5px; */
    line-height: 19.2px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .fcc-btns-contianer {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: grid;
    margin-top: 24px;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;
    row-gap: 24px;
  }
`;

const TitleSm = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 140%;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: ${EverGreenStyle.title18};
  }
`;

const heading = css`
  margin-bottom: 36px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: unset;
  }
`;
